import { getBrandDiscounts } from "@faire/retailer-visitor-shared/serialized-data/getBrandDiscounts";
import { useQuery as useCartBrandDiscountsQuery } from "@faire/web-api--source/api/cart/brand-discounts/get-hooks";
import { useMemo } from "react";
export var useBrandDiscounts = function() {
    var _useCartBrandDiscountsQuery = useCartBrandDiscountsQuery({
        initialData: getBrandDiscounts,
        staleTime: Infinity
    }), data = _useCartBrandDiscountsQuery.data, refetch = _useCartBrandDiscountsQuery.refetch;
    return useMemo(function() {
        var _data_brand_discounts;
        var brandDiscounts = (_data_brand_discounts = data === null || data === void 0 ? void 0 : data.brand_discounts) !== null && _data_brand_discounts !== void 0 ? _data_brand_discounts : {};
        return {
            brandDiscounts: brandDiscounts,
            refetch: refetch
        };
    }, [
        data === null || data === void 0 ? void 0 : data.brand_discounts,
        refetch
    ]);
};
